var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9982 1.32668C15.9793 0.94678 15.7905 0.603063 15.5072 0.349798C15.2239 0.0965325 14.8462 -0.0301001 14.4496 0.0060807C14.053 0.0241711 13.6941 0.205075 13.4486 0.47643L5.89421 8.6171L2.43807 5.6141C2.15478 5.36083 1.77706 5.2342 1.38045 5.25229C0.983847 5.27038 0.625013 5.43319 0.379495 5.70455C0.115091 5.9759 -0.0171108 6.33771 0.0017752 6.71761C0.0206612 7.09751 0.190635 7.44122 0.473925 7.6764L5.02545 11.6382C5.28986 11.8734 5.64869 12 6.00752 12H6.08307H6.10195C6.47967 11.9819 6.83851 11.8191 7.1218 11.5297L15.6583 2.32165C15.8849 2.05029 16.0171 1.68849 15.9982 1.32668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle_tick.7d1ce140b8a9487f634a4329711bd7b8.svg";
export { ForwardRef as ReactComponent };